import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router";

import { routes } from "./routes";

/**
 * Hydration.
 *
 * The server serialised its loader data into window.__staticRouterHydrationData,
 * so the router starts with everything the markup was rendered from and makes
 * no request on first paint. Without it every page would refetch its own
 * content immediately after loading, which is the sort of thing that does not
 * show up on a fast connection and doubles the wait on a slow one.
 */
const router = createBrowserRouter(routes, {
  hydrationData: window.__staticRouterHydrationData,
});

startTransition(() => {
  hydrateRoot(
    document.getElementById("root")!,
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
});

declare global {
  interface Window {
    __staticRouterHydrationData?: Parameters<typeof createBrowserRouter>[1] extends { hydrationData?: infer H }
      ? H
      : never;
  }
}
